import type {NavItemType} from "./NavItemType";
import type {ItemType} from "antd/es/menu/interface";

const modules = import.meta.glob<{ navItem: NavItemType }>(
    "../routes/**/nav.tsx",
    {eager: true},
);

export function buildMenuItems(): ItemType[] {
  const items: NavItemType[] = [];

  for (const mod of Object.values(modules)) {
    if (mod.navItem) {
      items.push(mod.navItem);
    }
  }

  return items.sort((a, b) => (a.order ?? 1000) - (b.order ?? 1000));
}
